import { ca } from '@cian/analytics';

type TSiteType = 'desktop' | 'mobile';

type TrackNavigationEventProps = {
  category: 'CompareJK' | 'Compare';
  action: 'to_listingjk' | 'to_flats';
  pageType: 'ListingCompareJK' | 'ListingCompare';
  siteType: TSiteType;
};

function trackNavigationEvent({ category, action, pageType, siteType }: TrackNavigationEventProps) {
  return ca('eventSite', {
    name: 'oldevent',
    category: category,
    action: action,
    label: 'empty_list',
    page: {
      siteType: siteType,
      pageType: pageType,
    },
  });
}

export function trackNavigationToFlats(siteType: TSiteType) {
  trackNavigationEvent({ category: 'Compare', action: 'to_flats', pageType: 'ListingCompare', siteType });
}

export function trackNavigationToJK(siteType: TSiteType) {
  trackNavigationEvent({ category: 'CompareJK', action: 'to_listingjk', pageType: 'ListingCompareJK', siteType });
}
